import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';

import {
    MobiUiIconComponent,
    MobiUiSidenavComponent,
    MobiUiSidenavItemComponent,
} from '@mobi/rwc-ui-components-ng-jslib';
import { TealiumTrackLinkOnsiteDirective } from '@mobi/tea-tagmanager-ng-jslib';

import { GiveMeMoreComponent } from '../../feature/give-me-more/give-me-more.component';
import { SidenavItem } from '../../model/sidenav';

@Component({
    selector: 'oiv-viewer-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [
        RouterLink,
        RouterLinkActive,
        MobiUiSidenavComponent,
        MobiUiSidenavItemComponent,
        GiveMeMoreComponent,
        TealiumTrackLinkOnsiteDirective,
        MobiUiIconComponent,
    ],
    providers: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
    #activatedRoute = inject(ActivatedRoute);
    navigationClick = output();
    sidenavItems = input<SidenavItem[]>([]);
    params = toSignal(this.#activatedRoute.params);
    baseUrlForResponsiveSidenavBackNavigation = computed(() => {
        const language = this.params()?.['language'];
        return (language ? `/${language}` : '') + `/avb/${this.params()?.['urlName']}`;
    });
    queryParams = toSignal(this.#activatedRoute.queryParams);

    closeOverlay() {
        this.navigationClick.emit();
    }
}
